import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CourseModel } from '@generativ/much-smarter-models';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { CourseService } from '../course.service';
import { SubjectService } from '../../../shared/subject.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, ...MATERIAL_IMPORTS, CapitalizePipe, SpinnerComponent],
  selector: 'app-course-management',
  templateUrl: './course-management.component.html',
  styleUrls: ['./course-management.component.scss']
})
export class CourseManagementComponent implements OnInit {

  courseId: number;
  readonly course = signal<CourseModel | null>(null);
  private subjects: string[];

  constructor(private route: ActivatedRoute,
              private courseService: CourseService) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.courseId = +params['courseId'];
      this.courseService.getCourse(this.courseId).subscribe(
        courseModel => {
          this.course.set(courseModel);
        }
      );
    });
  }
}
